import angular = require("angular");

class ServicesClass {
    static $inject = ["$q", "$log", "$http"];
    constructor(public $q: ng.IQService, public $log: ng.ILogService, public $http: ng.IHttpService) {
    }
}

export var Services: ServicesClass = angular.injector(["ng"]).instantiate(ServicesClass);



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/angularservicehelper.ts